import React, { useEffect, useRef } from 'react';

const ProjectBrandDetail = () => {

    const bannerRef = useRef(null);

    const scrollToContent = () => {
        if (bannerRef.current) {

            const bannerBottom = bannerRef.current.offsetHeight;


            window.scrollTo({
                top: bannerBottom,
                behavior: 'smooth'
            });
        }
    };


    useEffect(() => {
        const handleScroll = () => {
            if (!bannerRef.current) return;

            const bannerHeight = bannerRef.current.offsetHeight;
            const scrollY = window.scrollY;

            if (scrollY < bannerHeight - 80) {
                document.body.classList.add('nav-especial');
            } else {
                document.body.classList.remove('nav-especial');
            }
        };

        window.addEventListener('scroll', handleScroll);


        handleScroll();

        return () => {
            window.removeEventListener('scroll', handleScroll);
            document.body.classList.remove('nav-especial');
        };
    }, []);


    return (
        <div className="pds-main-wrapper">
            <div className="moti-banner-full" ref={bannerRef}>
                <img
                    src="../images/AE2/AE.jpg"
                    alt="Banner Principal"
                    className="moti-banner-img"
                />
                <div className="moti-banner-content">
                    <span className='moti-banner-mini'>American Eagle</span>
                    <h1 className="moti-banner-title">Primavera w/Domelipa</h1>
                    <span
                        className='moti-banner-button'
                        onClick={scrollToContent}
                        style={{ cursor: 'pointer' }}
                    >
                        Conoce el proyecto
                        <img
                            src="../images/AE/chevron.png"
                            alt="Banner Principal"
                            className="moti-banner-extra"
                        />
                    </span>
                </div>
            </div>
            <div className="pds-content-card">
                {/* Header con indicadores */}
                <header className="pds-header-group">
                    <img
                        src="/images/logo/MotiPuntos.svg"
                        alt="dots"
                        className="blog-moti-dots"
                    />
                    <p className="pds-label-top">CONOCE EL PROYECTO</p>
                    <h1 className="pds-main-title">Conociendo la marca y sus objetivos</h1>
                </header>

                <div className="pds-sections-container">
                    {/* Bloque 1: American Eagle */}
                    <div className="pds-feature-block">
                        <div className="pds-text-column">
                            <span className="pds-badge pds-bg-mint"> <img src="../images/AE/r.png" alt="Img 1" /></span>
                            <h2 className="pds-section-heading">American Eagle</h2>
                            <p className="pds-description">
                                American Eagle es una marca global de moda reconocida por su estilo juvenil, fresco y cercano a las tendencias. 
                                Para esta campaña de primavera, el objetivo fue crear un escaparate atractivo y estacional que conectara con su audiencia, 
                                transmitiera frescura y renovara visualmente el punto de venta, reforzando la experiencia de marca desde el exterior de la tienda.
                                <br /> <br />


                                <span className="pds-badge pds-bg-peach"><img src="../images/AE/trazo.png" alt="Img 1" /></span>
                                <h2 className="pds-section-heading">Entendiendo el espacio para diseñar con propósito</h2>
                                El proyecto se desarrolló para el escaparate de tiendas departamentales, 
                                un espacio clave del retail donde la visibilidad es fundamental. 
                                Analizamos dimensiones, profundidad e iluminación para crear un escenario que 
                                destacara desde distintos ángulos y captara la atención del consumidor desde el primer contacto.

                            </p>
                        </div>
                        <div className="pds-visual-stack pds-bg-guide-mint">
                            <div className="pds-img-holder pds-rotate-left">
                                <img src="../images/AE2/AE (3).jpg" alt="Img 1" />
                            </div>

                            <div className="pds-img-holder pds-center">
                                <img src="../images/AE2/AE (6).jpg" alt="Img 2" />
                            </div>

                            <div className="pds-img-holder pds-rotate-right pds-overlay">
                                <img src="../images/AE2/AE (7).jpg" alt="Img 3" />
                            </div>
                        </div>
                    </div>

                    {/* Bloque 2: Espacio (Invertido) */}
                    <div className="pds-feature-block pds-row-reverse">
                        <div className="pds-text-column-rigth">
                            <span className="pds-badge pds-bg-grape"><img src="../images/AE/foco.png" alt="Img 1" /></span>
                            <h2 className="pds-section-heading rigth">De la Idea a lo  <br /> tangible: Producción y Acabados</h2>
                            <p className="pds-description rigth">
                               Se creó un escenario primaveral con pasto sintético y elementos volumétricos en MDF para 
                               dar estructura y profundidad al escaparate. Mariposas en PETG complementaron el diseño, 
                               reforzando el concepto de temporada con movimiento visual y coherencia de marca.

                            </p>
                        </div>
                        <div className="pds-visual-grid">
                            <img src="../images/AE2/AE (4).jpg" className="pds-grid-img img1" alt="Store view" />
                            <img src="../images/AE2/AE (7).jpg" className="pds-grid-img img2" alt="Close up" />
                        </div>
                    </div>

                    <div className="pds-bottom-block ">
                        <span className="pds-badge pds-bg-salmon"><img src="../images/AE/can.png" alt="Img 1" /></span>
                        <h2 className="pds-section-heading rigth">¿Por qué elegimos estos materiales?</h2>
                        <p className="pds-description rigth">
                            <strong>El pasto sintético</strong> permitió recrear una sensación natural y fresca
                             sin comprometer durabilidad ni mantenimiento. <strong>El MDF</strong> fue seleccionado por su versatilidad, 
                             resistencia y capacidad para crear volúmenes personalizados que aportan profundidad al escaparate. 
                             <strong>El PETG</strong>, utilizado en las mariposas, ofreció ligereza, resistencia y un acabado limpio, 
                             ideal para elementos decorativos que requieren precisión visual y estabilidad en punto de venta.
                        </p>
                        <img src="../images/AE2/AE (9).jpg" className="bannerAE" alt="Close up" />
                    </div>
                    <div className="moti-container">
                        {/* Bloque: El Resultado */}
                        <section className="moti-section moti-center">
                            <div className="moti-icon-box moti-pink">
                                <span className="moti-icon"><img src="../images/AE/badge.png" alt="Img 1" /></span>
                            </div>
                            <h2 className="moti-title">El resultado: Impacto en el punto de venta</h2>
                            <p className="moti-description">
                                El escaparate logró transmitir una atmósfera primaveral clara y atractiva, 
                                generando mayor visibilidad y reforzando el mensaje de temporada de American Eagle. 
                                La combinación de materiales, volúmenes y elementos gráficos creó un punto focal que captó la atención
                                 de los clientes y enriqueció la experiencia visual en tienda.
                            </p>
                        </section>

                        {/* Bloque: Servicios y Stack de Imágenes */}
                        <section className="moti-services-layout">
                            <div className="moti-services-text">
                                <h3 className="moti-subtitle">Servicios representados en este proyecto:</h3>

                            </div>
                            <div>
                                <ul className="moti-list">
                                    <li>• Desarrollo y ejecución de proyectos</li>
                                    <li>• Producción especializada</li>
                                    <li>• Instalación en punto de venta</li>
                                    <li>• Coordinación comercial para objetivos visuales</li>
                                </ul>
                            </div>
                        </section>
                        <div className="moti-image-stack">
                            <img src="../images/AE2/AE (5).jpg" alt="Domelipa AE" className="moti-img-card moti-tilt-left" />
                            <img src="../images/AE2/AE (10).jpg" alt="American Eagle Neon" className="moti-img-card moti-tilt-right " />
                            <img src="../images/AE2/AE (2).jpg" alt="American Eagle Neon" className="moti-img-card moti-tilt-center" />
                        </div>

                        {/* Bloque: Destaque de Portafolio */}
                        <section className="moti-section moti-center">
                            <h2 className="moti-title">¿Por qué este proyecto destaca en<br /> nuestro portafolio?</h2>
                            <img
                                src="/images/logo/MotiPuntos.svg"
                                alt="dots"
                                className="blog-moti-dots"
                            />
                            <p className="moti-description">
                               Este caso refleja nuestra capacidad para traducir conceptos de temporada en escenarios 
                               físicos funcionales y visualmente atractivos, combinando diseño, 
                               producción y ejecución. Destaca por el uso estratégico de materiales, 
                               la creación de volumen en escaparate y la coherencia visual con la identidad de marca, 
                               consolidando a Moti Digital como un aliado experto en visual merchandising para retail.
                            </p>
                        </section>

                        {/* Footer Logo */}
                        <footer className="moti-brand-footer">
                            <img src="../images/AE/moti.png" alt="Img 1" className='moti-lgo' />
                            <img src="../images/AE/ready.png" alt="Img 1" className='ready' />
                        </footer>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProjectBrandDetail;